export default __webpack_public_path__ + "static/media/nidful.6211e9fe.png";